<template>
  <div class="text-center">
    <font-awesome-icon :icon="['fas', 'fa-spinner']" class="fa-4x fa-spin"></font-awesome-icon>
  </div>  
</template>

<script lang="ts">
export default {}
</script>
